import React from 'react'
// components
import ObjectivesContainer from 'containers/Objectives/Register'

const ObjectivesPage: React.FC = () => <ObjectivesContainer />

export default ObjectivesPage
